import dnLogo from '../../ui/assets/dn-logo.png';

/**
 * Mock store configurations for testing/demo purposes
 * These override the API response with custom branding while using real course data
 */
export const MOCK_STORES = {
  dn: {
    storeName: 'DNonlinekurser',
    owner: {
      name: 'Dagens Nyheter',
      id: 1153909,
    },
    theme: {
      color: '#D60505',
      logoUrl: dnLogo,
    },
    // Course IDs to fetch from user 1153909
    courseIds: [10435, 10549, 12796, 12311, 12303, 12332, 10437, 10436, 10554, 11830],
  },
};

/**
 * Check if a store name has mock configuration
 */
export const isMockStore = (storeName) => {
  return storeName && MOCK_STORES[storeName.toLowerCase()];
};

/**
 * Get mock store config
 */
export const getMockStore = (storeName) => {
  return MOCK_STORES[storeName?.toLowerCase()] || null;
};

/**
 * Get the real store name to use for API calls
 * If it's a mock store, returns the mock's storeName (e.g., 'dn' -> 'DNonlinekurser')
 * Otherwise returns the original storeName
 */
export const getApiStoreName = (storeName) => {
  const mockConfig = getMockStore(storeName);
  return mockConfig?.storeName || storeName;
};

/**
 * Apply mock branding to store data while preserving real course data
 */
export const applyMockBranding = (storeName, realStoreData) => {
  const mockConfig = getMockStore(storeName);
  if (!mockConfig) return realStoreData;

  return {
    ...realStoreData,
    owner: {
      ...realStoreData?.owner,
      ...mockConfig.owner,
    },
    theme: {
      ...realStoreData?.theme,
      ...mockConfig.theme,
    },
  };
};
